import { useEffect, useState } from "react";
import { Address, AddressPayload } from "../types";
import { useApi } from "../shared/api";
import { selectLoggedUser } from "../redux/slices/auth";
import { useDispatch, useSelector } from "react-redux";
import { getIPAddress, showToastError, showToastErrorInfo } from "../shared/utils/utils";
import { FileErrorCode } from "../shared/constants";
import { selectUtmCampaign } from "../redux/slices/utm";
import { setAddress } from "../redux/slices/address";

export const useAddressManager = () => {
    const API = useApi()
    const dispatch = useDispatch();
    const authInfo = useSelector(selectLoggedUser)
    const [addresses, setAddresses] = useState<Address[] | []>([]);
    const [loading, setLoading] = useState(false)
    const [isDetecting, setIsDetecting] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState<Address| null>(null);
    const [error, setError] = useState("")
 const utm_query = useSelector(selectUtmCampaign)
 
  useEffect(()=>{
    if(addresses.length > 0 && !selectedAddress){
      setSelectedAddress(addresses[0])
    } 
  }, [addresses])

    const addAddress = async (address:AddressPayload) => {
      try{
         if (!address.city || !address.state) {
    showToastErrorInfo("Pincode is not serviciable.");
    return;
  }
        setLoading(true)
        const response = await API.API_V1.address.postAddress(address)
        const newAddress = response.data;
        setSelectedAddress(newAddress)
        setAddresses(prev => [...prev, newAddress]);
        setLoading(false)
        return newAddress;
      }catch(err:any){
       setError(err.name)
       showToastError(FileErrorCode.ADDRESS,101,`${err.name}`)
       setLoading(false)
      }
       
    }

    const updateAddress = async (id:number, updateData:Partial<Address> | Address) => {
       if (!updateData.city || !updateData.state) {
    showToastErrorInfo("Pincode is not serviciable.");
    return;
  }
        setLoading(true)
        const response = await API.API_V1.address.patchAddress(updateData,id)
dispatch(
  setAddress({
    city: updateData.city,
    state: updateData.state,
    pincode: updateData.pincode,
    address_1: updateData.address_1,
    address_2: updateData.address_2,
    landmark: updateData.landmark,
  })
);
        const updatedAddress = response.data
        setAddresses(prev => prev.map(add => add.address_id == id ? {...add, ...updateData} : add))
        setLoading(false)
        return updatedAddress;
    }


    const deleteAddress = (id:Address['address_id']) => {
        // const deletedAddress = await 
        
        setAddresses(prev => prev.filter(addr => addr.address_id != id));
        if(selectedAddress && selectedAddress?.address_id == id){
            setSelectedAddress(null)
        }
    }


const detectMyLocationAddress = async (latitude:any,longitude:any) => {
  try {
setIsDetecting(true)
    let name:any;
    let email:any;

     if(authInfo.profileComplete ){
       name = authInfo.name
       email = authInfo.email 
    }
    // call your reverse geocoding endpoint (you used API.API_V1.address.getCoordinates)
    const response = await API.API_V1.address.getCoordinates({lat:latitude,lng:longitude });

    if (!response || !response.data || !response.data.results || !response.data.results.length) {
      console.error("Reverse geocode returned no results", response);
      return null;
    }

    const firstResult = response.data.results[0];
    const addressComponents = firstResult.address_components || [];
    const fullAddress = firstResult.formatted_address || "";

    const findComp = (type: string) =>
      addressComponents.find((c: any) => Array.isArray(c.types) && c.types.includes(type))?.long_name;

    const city =
      findComp("locality") ||
      findComp("sublocality") ||
      findComp("administrative_area_level_2") ||
      findComp("administrative_area_level_1") ||
      "Unknown city";

    const state = findComp("administrative_area_level_1") || "Unknown state";

    const address_1_parts = [
      findComp("street_number"),
      findComp("premise"),
      findComp("route"),
      findComp("sublocality_level_2"),
    ].filter(Boolean);

    const address_1 = address_1_parts.join(" ").trim() || (fullAddress || "Detected Address");

    const address_2 =
      findComp("sublocality_level_1") ||
      findComp("neighborhood") ||
      (fullAddress.split(",")[1] || "").trim() || "";

    const pincode = findComp("postal_code") || "";

    const landmark = findComp("point_of_interest") || findComp("premise") || "";

    const payload: AddressPayload = {
      name: name ,
      email: email ,
      address_1: address_1 || "Detected Address",
      // keep your earlier logic: if address_2 is 'Unknown locality' or empty fallback to piece of fullAddress
      address_2: address_2 && address_2 !== "Unknown locality" ? address_2 : (fullAddress.split(",")[1] || "").trim(),
      city,
      state,
      pincode: pincode && pincode !== "Unknown pincode" ? pincode : "",
      landmark: landmark || "",
    };
 const ip_address = await getIPAddress();
           const reqBody = { 
                                pincode: pincode && pincode !== "Unknown pincode" ? pincode : "", 
                                city: city, 
                                locality: null, 
                                user_id: authInfo.userId || null, 
                                user_agent: navigator.userAgent, 
                                ip_address: ip_address 
                            }
                        
                        const saveLocationLog = await API.API_V1.address.postLocationLog(reqBody,utm_query)
    setIsDetecting(false)
    return payload;

  } catch (err) {
    console.error("detectMyLocationAddress failed:", err);
    return null;
  }
};



    const getSelectedAddress = () => {
     

      return selectedAddress
       

    }


    const selectAddress = (id:number) => {
        
        const address = addresses.find(addr => addr.address_id == id);
        address 
        ? setSelectedAddress(address)
        : setSelectedAddress(null)

        
    }


    return {
       addresses,
       selectedAddress,
       addAddress,
       updateAddress,
       deleteAddress,
       getSelectedAddress,
       selectAddress,
       setAddresses,
       detectMyLocationAddress,
       loading,
       isDetecting,
       error
    }




}